import { createBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";

import { ProvidersAndConfigs } from "@components/ProvidersAndConfigs";

const routeEnvelope = () => import("@pages/Envelope");
const routeReformalizacao = () => import("@pages/Reformalizacao");
const routeRetention = () => import("@pages/Retention");
const routeDigitalRetention = () => import("@pages/DigitalRetention");
const routeVhagarServiceWapp = () => import("@pages/VhagarServiceWapp");

export const router = createBrowserRouter(
  [
    {
      element: <ProvidersAndConfigs />,
      children: [
        {
          path: "/",
          lazy: () => import("@pages/Home"),
        },
        {
          path: "/:token",
          lazy: () => routeEnvelope(),
        },
        {
          path: "/envelope/:token",
          lazy: () => routeEnvelope(),
        },
        {
          path: "/:token/rogado",
          lazy: () => routeEnvelope(),
        },
        {
          path: "/:token/reformalizacao",
          lazy: () => routeReformalizacao(),
        },
        {
          path: "/:token/reformalizacao/rogado",
          lazy: () => routeReformalizacao(),
        },
        {
          path: "/retencao/:token",
          lazy: () => routeRetention(),
        },
        {
          path: "/retencao-digital/:token",
          lazy: () => routeDigitalRetention(),
        },
        {
          path: "/in100/:cpf/:beneficio",
          lazy: () => import("@pages/In100"),
        },
        {
          path: "/autorizacao-consignado-privado/:cpf/",
          lazy: () => import("@pages/autorizacao-consignado-privado"),
        },
        {
          path: "/in100/:cpf/",
          lazy: () => import("@pages/In100"),
        },
        {
          path: "/autorizacao-in100/:cpf",
          lazy: () => import("@pages/In100"),
        },
        {
          path: "/user/:uniqueId",
          lazy: () => import("@pages/User"),
        },
        {
          path: "/linked-user/:uniqueId",
          lazy: () => import("@pages/Employement"),
        },
        {
          path: "/wapp/:token",
          lazy: () => routeVhagarServiceWapp(),
        },
      ],
    },
  ],
  {
    future: {
      v7_normalizeFormMethod: true,
    },
  },
);
